import React, {Fragment} from "react";
import {Col, FormGroup, FormText, Input, Label, Row} from "reactstrap";
import {InputAdapter, TextMask} from "react-text-mask-hoc";
import {getFormFieldValue, setFormFieldValue} from '../shared/shared';
import {Address} from "./Address";

export function Physician(props) {
  const {values, handleCB, readonly, token, formFields, showAddress = true, showTreatmentLine = true, showDiagnosisLine = true} = props;

  return (
    <Fragment>
      {showDiagnosisLine && (
        <Row>
          <Col xs={"4"}>
            <FormGroup>

              <Label htmlFor="condition">Condition/Diagnosis*</Label>
              <Input type="text" id="condition" placeholder=""
                     value={getFormFieldValue(values.condition)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
            </FormGroup>
          </Col>
          <Col xs={"3"}>
            <FormGroup>
              <Label htmlFor="medication">Medication Prescribed*</Label>
              <Input type="text" id="medication" placeholder=""
                     value={getFormFieldValue(values.medication)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
            </FormGroup>
          </Col>
        </Row>
      )}
      {showTreatmentLine && (
        <Row>
          <Col xs={"2"}>
            <FormGroup>
              <Label htmlFor="diagnosisDate">Diagnosis Date*</Label>
              <TextMask
                mask={[/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /[09]/, /\d/, /\d/]}
                Component={InputAdapter}
                className="form-control"
                id="diagnosisDate"
                value={getFormFieldValue(values.diagnosisDate)}
                onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
              />
              <FormText color="muted">
                MM/DD/YYYY (ex. 08/26/1984)
              </FormText>
            </FormGroup>
          </Col>
          <Col xs={"2"}>
            <FormGroup>
              <Label htmlFor="treatmentDate">Last Treatment*</Label>
              <TextMask
                mask={[/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /[09]/, /\d/, /\d/]}
                Component={InputAdapter}
                className="form-control"
                id="treatmentDate"
                value={getFormFieldValue(values.treatmentDate)}
                onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
              />
              <FormText color="muted">
                MM/DD/YYYY (ex. 08/26/1984)
              </FormText>
            </FormGroup>
          </Col>
          <Col xs={"3"}>
            <FormGroup>
              <Label htmlFor="treatmentType">Treatment Type*</Label>
              <Input type="text" id="treatmentType" placeholder=""
                     value={getFormFieldValue(values.treatmentType)}
                     onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
            </FormGroup>
          </Col>

        </Row>
      )}
      <br/>
      {showAddress && (
        <Fragment>
          <Row>
            <Col xs={"4"}>
              <FormGroup>
                <Label htmlFor="physicianName">Physician Name*</Label>
                <Input type="text" id="physicianName" placeholder=""
                       value={getFormFieldValue(values.physicianName)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
              </FormGroup>
            </Col>
            <Col xs={"3"}>
              <FormGroup>
                <Label htmlFor="physicianPhone">Physician&nbsp;Phone&nbsp;Number*</Label>
                <TextMask
                  mask={[/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                  Component={InputAdapter}
                  className="form-control"
                  id={"physicianPhone"}
                  value={getFormFieldValue(values.physicianPhone)}
                  onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
                />
                <FormText color="muted">
                  ex. ###-###-####
                </FormText>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col xs={"3"}>
              <FormGroup>
                <Label htmlFor="physicianVisit">Date of Last Visit*</Label>
                <TextMask
                  mask={[/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /[09]/, /\d/, /\d/]}
                  Component={InputAdapter}
                  className="form-control"
                  id="physicianVisit"
                  value={getFormFieldValue(values.physicianVisit)}
                  onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}
                />
                <FormText color="muted">
                  MM/DD/YYYY (ex. 08/26/1984)
                </FormText>
              </FormGroup>
            </Col>
            <Col xs={"4"}>
              <FormGroup>
                <Label htmlFor="physicianReason">Reason for Visit*</Label>
                <Input type="text" id="physicianReason" placeholder=""
                       value={getFormFieldValue(values.physicianReason)}
                       onChange={(evt) => setFormFieldValue(evt.target.id, evt.target.value, values, readonly, handleCB)}/>
              </FormGroup>
            </Col>

          </Row>

          <Address values={values || {}}
                   handleCB={(field, value) => setFormFieldValue(field, value, values, readonly, handleCB)}
                   thisId={"physician"} readonly={readonly} formFields={formFields} token={token}/>
        </Fragment>
      )}
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Applications/components/Physician.js